import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  DateField,
  useTheme,
  usePermissions,
} from "react-admin";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import PurchaseGoodsInTransitExpandList from "../../components/purchaseGoodsInTransits/expand/PurchaseGoodsInTransitExpandList";
import purchaseGoodsInTransitsFilterList from "../../components/purchaseGoodsInTransits/filter/purchaseGoodsInTransitsFilterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();
const purchaseGoodsInTransitDefaultFilters = {
  start_date: firstDate,
  end_date: lastDate,
};

const PurchaseGoodsInTransitList = () => {
  const { permissions } = usePermissions();
  const [theme] = useTheme("light");
  const { filterDefaultValues } = useCompanyScopedListFilters(
    purchaseGoodsInTransitDefaultFilters
  );

  const list = useMemo(
    () => (
      <ManualReportList
        title="Goods In Transit"
        empty={false}
        actions={<DownloadAction />}
        filters={purchaseGoodsInTransitsFilterList(permissions)}
        filter={{
          is_complete: 0,
        }}
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
        queryOptions={{ meta: { sort: ["purchase_orders.code ASC"] } }}
      >
        {/* TAMBAHKAN CHILDREN DI SINI */}
        <DatagridConfigurable
          expand={<PurchaseGoodsInTransitExpandList />}
          sx={{
            "& .column-comment": {
              maxWidth: "18em",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
          }}
        >
          {/* TAMBAHKAN FIELDS */}
          <TextField source="company.alias" label="Depo" />
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField source="date" label="Tanggal" />
          {/* Tambahkan field lainnya sesuai kebutuhan */}
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, filterDefaultValues]
  );
  
  return list;
};

export default PurchaseGoodsInTransitList;
